import fetch from 'auth/FetchInterceptor'

const institucionService = {}

var prefix  = "/api/institucion/"
///

institucionService.InfoGeneral = function () {
	return fetch({
		url: `${prefix}/config/general`,
		method: 'get',
	})
}

institucionService.Info = function () {
	return fetch({
		url: prefix,
		method: 'get',
	})
}

institucionService.Estructura = function () {
	return fetch({
		url: prefix+'estructura',
		method: 'get',
	})
}


institucionService.getPlanteles = function (id) {
	return fetch({
		url: prefix+"planteles/"+id,
		method: 'get',
	})
}


institucionService.getAllPlanteles = function (id) {
	return fetch({
		url: prefix+"planteles",
		method: 'get',
	})
}




institucionService.getSecciones = function (data) {
	return fetch({
		url: prefix+"secciones/"+data || '/',
		method: 'get',
	})
}


institucionService.getCiclos = function () {
	return fetch({
		url: prefix+"ciclos?id_seccion=",
		method: 'get',
	})
}




institucionService.getDptosAcademidos = function () {
	return fetch({
		url: prefix+"dptosacademicos",
		method: 'get',
	})
}

institucionService.getAulas= function (id_plantel = "undefined") {
	return fetch({
		url: "/api/aulas?id_plantel="+id_plantel,
		method: 'get',
	})
}

institucionService.getRoles= function () {
	return fetch({
		url: `${prefix}/roles`,
		method: 'get',
	})
}


//INSERTAR 




institucionService.Insertar = function (data) {
	return fetch({
		url: prefix,
		method: 'post',
		data: data
	})
}

institucionService.gradosEscolares = function (data) {
	return fetch({
		url: prefix+"gradosEscolares",
		method: 'post',
		data: data
	})
}

institucionService.seccionesInsertar = function (data) {
	return fetch({
		url: prefix+"secciones",
		method: 'post',
		data: data
	})
}

institucionService.seccionesAsignarProfe = function (idSeccion,data) {
	return fetch({
		url: prefix+`secciones/${idSeccion}/asignarProfesor`,
		method: 'post',
		data: data
	})
}

institucionService.ciclosInsertar = function (data) {
	return fetch({
		url: prefix+"ciclos",
		method: 'post',
		data: data
	})
}




institucionService.PlantelInsertar= function (data) {
	return fetch({
		url: prefix+"planteles",
		method: 'post',
		data: data
	})
}


institucionService.PlantelAsignar= function (data) {
	return fetch({
		url: prefix+"planteles/relacionar-dpto",
		method: 'post',
		data: data
	})
}



institucionService.aulaInsertar= function (data) {
	return fetch({
		url: "/api/aulas",
		method: 'post',
		data: data
	})
}


institucionService.DptoAcademico = function (data) {
	return fetch({
		url: prefix+"dptosacademicos",
		method: 'post',
		data
	})
}


//ACTUALIZAR




institucionService.Update = function (data) {
	return fetch({
		url: prefix+data.id,
		method: 'put',
		data: data
	})
}



institucionService.ciclosUpdate = function (data) {
	return fetch({
		url: prefix+"ciclos/"+data.id,
		method: 'put',
		data: data
	})
}

institucionService.seccionesUpdate = function (data) {
	return fetch({
		url: prefix+"secciones/"+data.id,
		method: 'put',
		data: data
	})
}

institucionService.plantelUpdate = function (id,data) {
	return fetch({
		url: prefix+"planteles/"+id,
		method: 'put',
		data: data
	})
}


institucionService.aulaUpdate= function (data) {
	return fetch({
		url: prefix+"/api/aulas/"+data.id,
		method: 'put',
		data: data
	})
}

institucionService.DptoAcademicoUpdate = function (id,data) {
	return fetch({
		url: prefix+"dptosacademicos/"+id,
		method: 'put',
		data
	})
}

///ELIMINAR DELETE METHOD



institucionService.Delete = function (data) {
	return fetch({
		url: prefix,
		method: 'delete',
		data: data
	})
}

institucionService.gradosEscolaresDelete = function (data) {
	return fetch({
		url: prefix+"gradosEscolares/"+data.id,
		method: 'delete',
		data: data
	})
}


institucionService.ciclosDelete = function (id) {
	return fetch({
		url: prefix+"ciclos/"+id,
		method: 'delete',
		// data: data
	})
}

institucionService.seccionesDelete = function (data) {
	return fetch({
		url: prefix+"secciones/"+data,
		method: 'delete',
		data: data
	})
}

institucionService.plantelDelete = function (data) {
	return fetch({
		url: prefix+"planteles/"+data,
		method: 'delete',
		data: data
	})
}

institucionService.aulasDelete= function (id) {
	return fetch({
		url: prefix+"/api/aulas",
		method: 'put',
	})
}

institucionService.DptoAcademicoDelete = function (id) {
	return fetch({
		url: prefix+"dptosacademicos/"+id,
		method: 'delete',
	})
}

export default institucionService